import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Table } from 'reactstrap';
import { useDispatch } from 'react-redux';
import {getNumberAssignmentLog} from '../../actions/Numbers';
import Spinner from '../Spinner/Spinner';

const NumberChangeLog = ({number, isOpen, onShowLogCancel}) => {
  const token = localStorage.getItem('jwtToken') || null;

  const dispatch = useDispatch();
  const [data, setData] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(getNumberAssignmentLog(token, number))
      .then((data) => {
          setLoading(false)
          setData(data)
        })
      .catch(() => setLoading(false))
  }, [dispatch, number])

  return (
    <Modal size="lg" scrollable={true} style={{ maxWidth: '80vw', maxHeigth: '80vh' }} isOpen={isOpen}>
      <>
      {loading && <Spinner/>}
      </>
      {!loading && (
      <>
      <ModalHeader>
       Last 10 Assignment Change Log
      </ModalHeader>
    <ModalBody>
      <Row style={{height: '500px', overflowY: 'scroll'}}>
        <Col>
        <Table responsive>
          <thead>
            <tr>
              <th>
                Date
              </th>
              <th>
              Number Type
              </th>
              <th>
                Activity
              </th>
              <th>
                Company
              </th>
              <th>
                EpikBox
              </th>
              <th>
                ChangeUser
              </th>
              <th>
                Box Port
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) && data?.length > 0 ? data?.map((log) => {
              return(
                <tr>
                <td>
                  {log.timeStamp}
                </td>
                <td>
                  {log.numberType}
                </td>
                <td>
                  {log.activity}
                </td>
                <td>
                  {log.company}
                </td>
                <td>
                  {log.linkedBox}
                </td>
                <td>
                  {log.changeUser}
                </td>
                <td>
                  {log.port}
                </td>
                </tr>
              )
            }) : (<> <p> No Log Found </p> </>)}
          </tbody>
        </Table>
      </Col>
      </Row>
    </ModalBody>
    <ModalFooter>
    <Button color="secondary" onClick={onShowLogCancel}>
            Close
    </Button>
    </ModalFooter>
    </>
    )}
    </Modal>
  )
}

export default NumberChangeLog;
